let api = null;

export default ({ app }) => {
  api = app.config.globalProperties.$api;
};

export { api };
